// React libraries
import React from "react";
// Custom Styles
import { useStyles } from "./PageWrapperStyles";
// Material-UI Core
import Paper from '@mui/material/Paper';
export const PageWrapper = (props) => {
    const classes = useStyles(props);
    const { previewWidth, previewHeight } = props;
    return (React.createElement(Paper, { className: classes.paper, style: { width: previewWidth, height: previewHeight } }, props.children));
};
export default React.memo(PageWrapper);
